import React, { useState, useEffect, useRef } from "react";
import { createFilter } from "react-select";
import AgentService from "core/api/AgentService";
import AsyncSelect from "react-select/async";
import { Button } from "reactstrap";

export const PhoneSelectorInputComponent = ({
  value,
  setValue,
  setUnknownPhoneNumber
}) => {
  const [selected, setSelected] = useState(null);
  const [inputValue, setInputValue] = useState(null);
  const selectRef = useRef(null);

  const isPhoneNumber = (number) => {
    if (number) {
      return /^1?\d{10}$/.test(number);
    } else {
      return false;
    }

  }

  const filterNumbers = async (inputValue) => {
    if (!inputValue) {
      return [];
    }
    const responseData = await AgentService.getElevatorsByPhoneNumber(inputValue);

    if (responseData.model.length === 0) return null;

    return responseData.model.map((elevator) => ({
      value: elevator.id,
      label: `${elevator.phoneNumber} (${elevator.name})`,
    }));
  };

  const loadOptions = (inputValue, callback) => {
    setTimeout(async () => {
      var items = await filterNumbers(inputValue);
      callback(items);
    }, 1000);
  };

  const filterConfig = {
    ignoreCase: true,
    ignoreAccents: true,
    trim: true,
  };

  useEffect(() => {
    async function fetchData() {
      const elevators = await AgentService.getElevator(value)
      setSelected({ value: value, label: `${elevators.phoneNumber} (${elevators.name})` })
      setInputValue(elevators.phoneNumber)
    }
    if (value) {
      fetchData();
    }
  }, [])


  return (
    <AsyncSelect
      ref={selectRef}
      value={selected}
      filterOption={createFilter(filterConfig)}
      cacheOptions
      defaultOptions={false}
      loadOptions={loadOptions}
      onChange={(option) => {
        setValue(option?.value)
        setSelected(option)
        setInputValue(option?.label)
        setUnknownPhoneNumber(null);
      }}
      onInputChange={(input) => {
        setInputValue(input);
      }}
      getOptionLabel={(option) => `${option.label}`}
      isClearable
      placeholder="Search for phone number"
      noOptionsMessage={isPhoneNumber(inputValue) ? () => {
        return (
          <div style={{ textAlign: 'center' }}>
            <Button
              color="primary"
              onClick={() => {
                setSelected({ value: null, label: inputValue });
                setUnknownPhoneNumber(inputValue);
                selectRef.current?.blur();
              }}
            >
              Unknown Elevator
            </Button>
          </div>
        )
      }
        : () => "Enter Valid Number"
      }
    />

  );
};
